import React from 'react';
import { Shield, Users } from 'lucide-react';

const GroupSafetyBanner = ({ onOpenForm }) => {
  return (
    <section className="py-6 md:py-10 bg-gradient-to-r from-red-600 to-orange-600">
      <div className="container mx-auto px-3 sm:px-6 lg:px-8 max-w-5xl">
        <div className="text-white text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Shield className="w-6 h-6 md:w-8 md:h-8" />
            <Users className="w-6 h-6 md:w-8 md:h-8" />
          </div>
          <h3 className="text-xl md:text-3xl font-bold mb-2">
            Viaje em Grupo com Total Segurança
          </h3>
          <p className="text-sm md:text-lg mb-4 text-white/90">
            Guias especializados acompanhando o grupo durante toda a jornada
          </p>
          <button
            onClick={onOpenForm}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 md:py-3 md:px-8 rounded-full text-sm md:text-lg transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Solicitar Orçamento
          </button>
        </div>
      </div>
    </section>
  );
};

export default GroupSafetyBanner;
